export type InvoiceRowUsageSizes =
  (typeof InvoiceRowUsageSize)[keyof typeof InvoiceRowUsageSize]
export const InvoiceRowUsageSize = {
  Package: 'USAGE_SIZE_PACKAGE',
  Unit: 'USAGE_SIZE_DOSAGE_UNITS',
} as const

export type InvoiceRowUsageTypes =
  (typeof InvoiceRowUsageType)[keyof typeof InvoiceRowUsageType]
export const InvoiceRowUsageType = {
  Administered: 'ADMINISTERED',
  Prescription: 'PRESCRIPTION',
  Given: 'GIVEN',
  HomeDelivery: 'HOME_DELIVERY',
} as const

export type InvoiceRowItemTypes =
  (typeof InvoiceRowItemType)[keyof typeof InvoiceRowItemType]
export const InvoiceRowItemType = {
  Procedure: 'ITEM_TYPE_PROCEDURE',
  Supply: 'ITEM_TYPE_SUPPLY',
  Food: 'ITEM_TYPE_FOOD',
  LaboratoryAnalysis: 'ITEM_TYPE_LABORATORY_ANALYSIS',
  LaboratoryAnalysisPanel: 'ITEM_TYPE_LABORATORY_ANALYSIS_PANEL',
  Medicine: 'ITEM_TYPE_MEDICINE',
} as const
